import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=48f02fbe&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=48f02fbe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f02fbe"]])

export default __exports__